import React, { Component} from "react";
import { Link } from "react-router-dom";

class PostListPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            isLoaded: false,
            searching: false,
            posts: [],
            total_pages: 0,
            page: 1
        };
    }
    fetchPosts = id => {
        fetch("https://api.blog.programix.ct8.pl/api/posts?page=" + id)
            .then(res => res.json())
            .then(
                result => {
                    this.setState({
                        isLoaded: true,
                        posts: result.data,
                        total_pages: result.last_page
                    });
                },
                error => {
                    this.setState({
                        isLoaded: true,
                        error
                    });
                }
            );
    };
    componentDidMount() {
        this.fetchPosts(this.state.page); 
    }
    search = event => {
        this.setState({
            searching: true,
            page: 1,
            total_pages: 0
        });
        if (event.target.value !== "") {
            fetch("https://api.blog.programix.ct8.pl/api/posts/" + event.target.value + "?page=" + this.state.page)
                .then(res => res.json())
                .then(
                    result => {
                        this.setState({
                            searching: false,
                            posts: result.data,
                            total_pages: result.last_page
                        });
                    },
                    error => {
                        this.setState({
                            searching: false,
                            error
                        });
                    }
                );
        } else {
            this.fetchPosts(1);
        }
    }
    updatePage = id => {
        this.setState({page: id}, this.fetchPosts(id));
    };
    renderPagination = () => {
        let pagination = [];
        for (let i = 1; i<= this.state.total_pages; i++) {
            pagination.push(
                <li key={i} className={i === this.state.page ? "active page-item" : "page-item"} onClick={() => this.updatePage(i)} value={i}>
                    <button className="page-link">{i}</button>
                </li>
            );
        }
        return pagination;
    };
    renderList = () => {
        return this.state.posts.map(post => (
            <div className="post" key={post.name}>
                <h4><Link to={"/post/"+ post.seo_link}>{post.name}</Link></h4>
                <p className="desc">{post.desc}</p>
                <Link to={"/post/" + post.seo_link}><button type="button" className="enter-button">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                        <path d="M5 12l14 0"></path>
                        <path d="M13 18l6 -6"></path>
                        <path d="M13 6l6 6"></path>
                    </svg>
                </button></Link>
            </div>
        ));
    };
    render() {
        if (this.state.error) {
            return <p className="info">Błąd! Nie można wczytać danych!</p>;
        } else if (!this.state.isLoaded) {
            return <div className="loader"></div>
        } else {
            return (
            <div className="container-list">
            <div className="search-section">
                <form method="GET" action="">
                    <div className="search-bar-section">
                        <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                            <path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0"></path>
                            <path d="M21 21l-6 -6"></path>
                        </svg>
                        <input className="search-bar" placeholder="Wyszukaj" name="search-bar" id="search-bar" onChange={this.search}/>
                    </div>
                </form>
            </div>
            <div className="posts">
                <h3>Wszystkie posty</h3>
                <div className="posts-grid">
                    {this.renderList()}
                    
                </div>
                <ul className="pagination">
                    {this.renderPagination()}
                </ul>
            </div>
        </div>);
        }
    };
}
export {PostListPage };